// extracted by mini-css-extract-plugin
export var button = "pagination-module--button--v-Egz";
export var container = "pagination-module--container--RX3m2";
export var number = "pagination-module--number--aMC5z";
export var numbers = "pagination-module--numbers--Kpjp1";